import Button from 'components/base/Button';
import SearchBox from 'components/common/SearchBox/SearchBox';
import IMerchCategory from 'models/restful/IMerchCategory';
import { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import CategoryDropdown from '../CategoryDropdown/CategoryDropdown';

interface ProductListFilterProps {
  categories: IMerchCategory[];
  setSearchTerm: (text: string) => void;
  searchTerm: string;
  setSelectedCats: (newSelectedCats: IMerchCategory[]) => void;
}

function ProductListFilter({
  categories,
  setSearchTerm,
  searchTerm,
  setSelectedCats
}: ProductListFilterProps) {
  const [selectedCategories, setSelectedCategories] = useState<{
    [key: number]: IMerchCategory[];
  }>({});
  const [isFiltered, setIsFiltered] = useState(false);
  const [searchBoxKey, setSearchBoxKey] = useState(crypto.randomUUID());

  const handleCleanFilterClick = () => {
    setSelectedCategories({});
    setSelectedCats([]);
    setSearchTerm('');
    setSearchBoxKey(crypto.randomUUID());
    setIsFiltered(false);
  };

  const handleSearchChange = (txt: string) => {
    setSearchTerm(txt);
    setIsFiltered(
      txt.length > 0 ||
        Object.values(selectedCategories).some(arr => arr.length > 0)
    );
  };

  const handleCategoryChange = (
    categoryId: number,
    selected: IMerchCategory[]
  ) => {
    setSelectedCategories(prev => {
      const newSelected = { ...prev, [categoryId]: selected };
      setSelectedCats(Object.values(newSelected).flat());
      const hasCategories = Object.values(newSelected).some(
        arr => arr.length > 0
      );
      const hasSearch = searchTerm.length > 0;
      setIsFiltered(hasCategories || hasSearch);
      return newSelected;
    });
  };

  return (
    <div className="p-0">
      <Form>
        <Row className="mb-3">
          <Form.Group as={Col} md="12" controlId="exampleCity" className="row">
            <Form.Group
              as={Col}
              md="2"
              controlId="exampleCity"
              style={{ width: 'auto' }}
            >
              <SearchBox
                value={searchTerm}
                placeholder="Search"
                key={searchBoxKey}
                onChange={(txt: string) => handleSearchChange(txt)}
              />
            </Form.Group>
            {isFiltered && (
              <Form.Group as={Col} md="2" controlId="exampleCity">
                <Button
                  variant="link"
                  className="me-3"
                  onClick={handleCleanFilterClick}
                  size="sm"
                >
                  Clear all
                </Button>
              </Form.Group>
            )}
          </Form.Group>
          <Form.Group as={Col} md="12" controlId="exampleCity" className="row">
            {categories.map(cat1 => (
              <Form.Group as={Col} md="3" key={cat1.ID} controlId="exampleCity">
                <CategoryDropdown
                  key={cat1.ID}
                  isFiltered={isFiltered}
                  title={cat1.Title}
                  categories={cat1.SubCategories}
                  onCategoryChange={(catId, selected) =>
                    handleCategoryChange((catId = cat1.ID), selected)
                  }
                  categoryId={cat1.ID}
                />
              </Form.Group>
            ))}
          </Form.Group>
        </Row>
      </Form>
    </div>
  );
}

export default ProductListFilter;
